import React, { useCallback, useMemo, useState } from 'react';
import Loadable from 'react-loadable';
import { createProvider } from '../../../../utils/createProvider';
// import { UserChangePasswordModal } from '../../../user/components/UserChangePassword/UserChangePasswordModal';
import { HeaderActionsProviderValues } from './types';
import { useLazyModalOpenState } from '../../../../components/ModalBox/useLazyModalOpenState';
import { useUserPageContextState } from '../../../user/index';

const LoadableUserChangePasswordModal = Loadable({
	loader: () =>
		import('../../../user/components/UserChangePassword/UserChangePasswordModal').then(
			(m) => m.UserChangePasswordModal,
		),
});

const [Provider, useHeaderActionsProvider] = createProvider<HeaderActionsProviderValues>({
	contextName: 'HeaderActionsContext',
});

const HeaderActionsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
	const { isAuthenticated } = useUserPageContextState();
	const openChangePasswordModal = useCallback(() => {
		setIsChangePasswordOpen(true);
	}, []);
	const { shouldRender } = useLazyModalOpenState(isChangePasswordOpen);
	const closeChangePasswordModal = useCallback(() => {
		setIsChangePasswordOpen(false);
	}, []);

	const providerValues = useMemo(
		() => ({
			openChangePasswordModal,
		}),
		[openChangePasswordModal],
	);

	return (
		<>
			<Provider value={providerValues}>{children}</Provider>
			{isAuthenticated && shouldRender && (
				<LoadableUserChangePasswordModal
					isOpen={isChangePasswordOpen}
					onClose={closeChangePasswordModal}
				/>
			)}
		</>
	);
};

export { HeaderActionsProvider, useHeaderActionsProvider };
